import type { IconType } from "react-icons";
import { FaHandshake, FaInfoCircle, FaPaperPlane, FaTasks, FaUserCheck, FaUserTie } from "react-icons/fa";
import type { ContributingEntityDetailDto } from "../../../../autogen/bff-api";
import { defineWizardSteps } from "../../../../common/wizard/wizardSteps";

export const CONTRIBUTION_WIZARD_STEPS = [
  { key: "intro", icon: FaInfoCircle },
  { key: "supplier", icon: FaUserTie },
  { key: "exclusion", icon: FaUserCheck },
  { key: "qualification", icon: FaTasks },
  { key: "commitment", icon: FaHandshake },
  { key: "review", icon: FaPaperPlane },
] as const satisfies ReadonlyArray<{ key: string; icon: IconType }>;

export type ContributionStep = (typeof CONTRIBUTION_WIZARD_STEPS)[number]["key"];

export interface ContributionStepVisibility {
  hasExclusionCriteria: boolean;
  hasSelectionCriteria: boolean;
  commitmentRequired: boolean;
  canSubmit: boolean;
}

export const contributionStepVisibility = (
  detail: ContributingEntityDetailDto,
  canSubmit = true,
): ContributionStepVisibility => ({
  hasExclusionCriteria: (detail.context.exclusionCriteria ?? []).length > 0,
  hasSelectionCriteria: (detail.context.selectionCriteria ?? []).length > 0,
  commitmentRequired: detail.commitmentRequired ?? false,
  canSubmit,
});

const isStepVisible = (key: ContributionStep, v: ContributionStepVisibility): boolean => {
  switch (key) {
    case "exclusion":
      return v.hasExclusionCriteria;
    case "qualification":
      return v.hasSelectionCriteria;
    case "commitment":
      return v.commitmentRequired;
    case "review":
      return v.canSubmit;
    default:
      return true;
  }
};

export const contributionWizardModel = defineWizardSteps<ContributionStep, ContributionStepVisibility>(
  CONTRIBUTION_WIZARD_STEPS,
  isStepVisible,
);
